import { render, staticRenderFns } from "./collectInformation.vue?vue&type=template&id=77cec731&scoped=true"
import script from "./collectInformation.vue?vue&type=script&lang=js"
export * from "./collectInformation.vue?vue&type=script&lang=js"
import style0 from "./collectInformation.vue?vue&type=style&index=0&id=77cec731&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cec731",
  null
  
)

export default component.exports